import { defineMessages } from 'react-intl'

const messages = {
  today: {
    id: 'app.components.cycle-header.today',
    defaultMessage: '{date}, Today',
  },
  count: {
    id: 'app.components.cycle-header.count',
    defaultMessage: `{ count, number } {count, plural,
      one { order }
      other { orders}
    }`,
  },
  labeledItems: {
    id: 'app.components.cycle-header.label-items',
    defineMessage: 'Labeled items',
  },
}

export default defineMessages(messages)
